import(/* webpackMode: "eager" */ "/vercel/path0/web/app/(main)/kaffeprat/page.tsx");
